import {
  LayoutDashboard,
  Globe,
  Map,
  Building2,
  Grid2x2,
  Landmark,
  IdCard,
  TimerIcon,
  Layers,
  Tags,
  BriefcaseBusiness,
  PanelsTopLeft,
  PackageSearch,
  Store,
  MessageCircle,
  Quote,
  FileStack,
  BookOpen,
  ShoppingBag,
  LibraryBig,
  Factory,
  Badge,
  FilePlus,
  Users,
  Home,
  UserIcon,
} from "lucide-react";

export const menuConfig = [
  {
    section: "MAIN",
    items: [
      {
        name: "Dashboard",
        path: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        name: "Master Data",
        icon: Grid2x2,
        children: [
          { name: "Countries",         path: "/master/countries",        icon: Globe },
          { name: "States",            path: "/master/state",            icon: Map },
          { name: "Cities",            path: "/master/city",             icon: Building2 },
          { name: "Categories",        path: "/master/category",         icon: Tags },
          { name: "Sub Categories",    path: "/master/subcategory",      icon: Layers },
          { name: "Business Type",     path: "/master/businesstype",     icon: BriefcaseBusiness },
          { name: "Designation",       path: "/master/designation",      icon: IdCard },
          { name: "Bank",              path: "/master/bank",             icon: Landmark },
          { name: "Delivery Timeline", path: "/master/deliverytimeline", icon: TimerIcon },
        ],
      },
      // { name: "RFQs",               path: "/rfq",               icon: Contact },
      { name: "Buyers Item Master", path: "/buyer-item-master", icon: PackageSearch },
      { name: "Vendors",             path: "/vendors",           icon: Store },
      { name: "Managed Vendors",     path: "/managed-vendors",   icon: Users },
      { name: "Contact Us",          path: "/contactus",         icon: MessageCircle },
      // { name: "Support Inbox",       path: "/support-inbox",     icon: MessagesSquare },
      { name: "Testimonials",        path: "/testimonials",      icon: Quote },
      {
        name: "Website CMS",
        icon: PanelsTopLeft,
        children: [
          { name: "Master Pages",
            icon: FileStack,
            children: [
              { name: "Home Page", path: "/cms/master/home-page", icon: Home },
              { name: "Case Study", path: "/cms/master/case-study", icon: BookOpen },
              { name: "Buyer Page", path: "/cms/master/buyer-page", icon: ShoppingBag },
              { name: "Supplier Page", path: "/cms/master/supplier-page", icon: UserIcon },
              { name: "Blog Page", path: "/cms/master/blog-page", icon: BookOpen },
              

            ]
           },
          { name: "Blogs", path: "/cms/blog-page", icon: BookOpen },
          { name: "Case Studies", path: "/cms/case-studies", icon: LibraryBig },
          { name: "Industries", path: "/cms/industries", icon: Factory },
          { name: "Our Brands", path: "/cms/our-brands", icon: Badge },
          { name: "Create Pages", path: "/cms/pages", icon: FilePlus },
          // { name: "Case Study Detail", path: "/cms/case-studies-detail", icon: BookOpen },
        ],
      },
      {
        name: "Catalog",
        icon: LibraryBig,
        children: [
          { name: "Overview", path: "/catalog", icon: LayoutDashboard, end: true },
          { name: "Brands", path: "/catalog/brands", icon: Badge },
          { name: "Products", path: "/catalog/products", icon: PackageSearch },
          // { name: "Supplier Pricing", path: "/catalog/supplier-pricing", icon: Tags },
        ],
      },
    ],
  },
];



//Case Study List Page
//case Study Detail Page 
//Buyer Page 
//Supplier Page
//Home Page
//Feature Page
